import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
 Component,
 EventEmitter,
 Inject,
 Input,
 Output,
 PLATFORM_ID,
 WritableSignal,
 effect,
 forwardRef,
 inject,
 signal,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HotelInfoUiService } from '../../../pages/accommodation-info/services/hotel-info-ui.service';
export const CUSTOM_COUNTER_VALUE_ACCESSOR: any = {
 provide: NG_VALUE_ACCESSOR,
 useExisting: forwardRef(() => CounterComponent),
 multi: true,
};

@Component({
 selector: 'iho-counter',
 standalone: true,
 imports: [CommonModule, MatIconModule, MatButtonModule],
 templateUrl: './counter.component.html',
 styleUrls: ['./counter.component.scss'],
 providers: [CUSTOM_COUNTER_VALUE_ACCESSOR],
})
export class CounterComponent implements ControlValueAccessor {
 constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

 // TODO: this dependency should NOT be placed in a shared component and should ne moved to smart component in next sprint
 pdpUiService = inject(HotelInfoUiService);
 @Input() outOfPackagePeriod = -1;
 @Input() state: { value: number; state: string }[] = [];
 @Input() disable = false;
 @Input({ required: false }) roomId!: any;
 @Input({ required: false }) extraPersonData!: any;
 @Input({ required: true }) type!: any;
 @Input() min = 0;
 @Input() max = 100;
 isMobile = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(window.navigator.userAgent)
  : '';

 @Input() set removeCount(e: boolean) {
  if (e) this.resetCountValue();
 }

 @Output() decreaseEvent = new EventEmitter<number>();
  @Output() increaseEvent = new EventEmitter<number>();
 currentValue: WritableSignal<number> = signal<number>(0);

 private onChange: (value: number) => void = () => {};
 private onTouched: () => void = () => {};

 resetCountAll = effect(
  () => {
   if (this.pdpUiService.resetCountAll() !== undefined) {
    this.currentValue.set(0);
    this.pdpUiService.resetCountSpecific.set(false);
   }
  },
  { allowSignalWrites: true }
 );

 resetCountSpecific = effect(
  () => {
   if (this.pdpUiService.resetCountSpecific() == this.roomId) {
    this.currentValue.set(0);
    if (isPlatformBrowser(this.platformId))
     setTimeout(() => {
      this.pdpUiService.resetCountSpecific.set(0);
     }, 200);
   }
  },
  { allowSignalWrites: true }
 );

 updateCurrentValue() {
  this.currentValue.set(Math.min(Math.max(this.currentValue(), this.min), this.max));
 }

 increase() {
  if (this.currentValue() < this.max && !this.disable) {
   this.currentValue.set(Math.min(this.currentValue() + 1, this.max));
    this.increaseEvent.emit(this.currentValue());
  }
 }

 decrease() {
  this.currentValue.set(Math.max(this.currentValue() - 1, this.min));
   this.decreaseEvent.emit(this.currentValue());
 }

 // ControlValueAccessor methods
 writeValue(value: number): void {
  this.currentValue.set(value);
  this.onChange(value);
 }

 registerOnChange(fn: (value: number) => void): void {
  this.onChange = fn;
 }

 registerOnTouched(fn: () => void): void {
  this.onTouched = fn;
 }

 resetCountValue() {
  this.currentValue.set(0);
 }
}
